<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--zero-balance modal--purchase" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_confirm_purchase_successfull_purchase }}</h1>
          <img class="usericon" src="static/images/purchase.svg" alt="">
        </div>
        <div class="modal__body">
          <p class="modal_strong">{{ getTranslations.home_modals_confirm_purchase_well_done }}</p>
          <p>
            {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' +  getTranslations.home_modals_confirm_purchase_successfull_games_were_unlocked : ''}}</p>
          <p> {{ getBundleData.numberOfGames && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :'' }}
          {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_successfull_points_were_added:''}}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_successfull_do_you_want_to_start_new_game }}</p>
        </div>
        <div class="modal__footer">
          <a class="btn2 btn2--std btn2--small btn2--fixed" style="cursor:pointer" @click.prevent="playMethod">
            {{ getTranslations.home_modals_confirm_purchase_successfull_new_game }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';

export default {
  name: 'confirmPurchaseSuccessful',
  data() {
    return {
      showedModal: false,
    };
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            console.log("----------------------- Correct ConfirmPurchaseSuccessful For  Store showHideModal");
            this.showedModal = true;
            this.storeModalForStore(null);
          } else {
            this.storeModalForStore(null);
          }
        });
      });
      /* eslint-enable */
    },
    playMethod() {
      console.log('showing resume game pop up in Store Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForStore(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForStore(ResubscribeGameSms);
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
          } else {
            this.storeModalForStore(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForStore(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForStore(null);
        }
        this.showModal();
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('common', [
      'modalForStore',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'userDetails',
    ]),
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseSuccessful.vue